/**
 * Logger en fejl uden request-/response-body og headers (ADV-349). En afvist axios-fejl eller
 * -respons indeholder `config.data`, dvs. hele PATCH-bodyen med fødselsdato og CPR-cifre, som
 * ellers havnede i browserkonsollen. Der logges kun status, besked, stack (for Error) samt
 * request-metode og -URL.
 */
interface RequestConfigLike {
  url?: unknown;
  method?: unknown;
}
interface ErrorLike {
  status?: unknown;
  statusText?: unknown;
  message?: unknown;
  config?: RequestConfigLike;
  response?: { status?: unknown; config?: RequestConfigLike };
}

function asString(value: unknown) {
  return typeof value === "string" || typeof value === "number"
    ? String(value)
    : undefined;
}

export function safeErrorSummary(error: unknown) {
  const e = (error ?? {}) as ErrorLike;
  const config = e.config ?? e.response?.config;
  const method = asString(config?.method)?.toUpperCase();
  const url = asString(config?.url);
  return {
    status: asString(e.status) ?? asString(e.response?.status),
    statusText: asString(e.statusText),
    message: asString(e.message),
    request:
      method || url ? [method, url].filter(Boolean).join(" ") : undefined,
    stack: error instanceof Error ? error.stack : undefined,
  };
}

export function logSafeError(error: unknown) {
  const { status, statusText, message, request, stack } =
    safeErrorSummary(error);
  console.error(
    "Fejl:",
    [status, statusText ?? message, request].filter(Boolean).join(" "),
    ...(stack ? ["\n" + stack] : []),
  );
}
